module.exports = __webpack_public_path__ + "fonts/NespressoLucas-BoldItalic.woff?v=e7d70f718bdbfea42b5ff0095e09e09f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-BoldItalic.woff
// module id = 647
// module chunks = 0